<template>
  <SingleLineField
    v-if="field.field_type === 'single_line'"
    :field="field"
    @update="update"
    :ref="field.id"
    :mask="field.validate ? field.validate : ''"
  />

  <MultiLineField
    v-if="field.field_type === 'multi_line'"
    :field="field"
    @update="update"
    :ref="field.id"
  />

  <RadioField v-if="field.field_type === 'radio'" :field="field" @update="update" :ref="field.id" />

  <YesOrNoField
    v-if="field.field_type === 'yes_no'"
    :field="field"
    @update="update"
    :ref="field.id"
  />

  <DateField v-if="field.field_type === 'date'" :field="field" @update="update" :ref="field.id" />

  <DropdownField
    v-if="field.field_type === 'dropdown'"
    :field="field"
    @update="update"
    :ref="field.id"
  />

  <TextDisplayField v-if="field.field_type === 'text_display'" :field="field" :ref="field.id" />
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
    },
  },
  emits: ['update'],
  computed: {
    isValid() {
      return this.$refs[this.field.id].isValid
    },
  },
  methods: {
    update(val) {
      this.$emit('update', val)
    },
    getFieldRef() {
      return this.$refs[this.field.id]
    },
    validateField() {
      this.$refs[this.field.id].validateField()
    },
  },
}
</script>
